
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 .833A6.67 6.67 0 00.334 7.5 6.669 6.669 0 007 14.167 6.67 6.67 0 0013.667 7.5 6.67 6.67 0 007 .833zm.667 10H6.334v-4h1.333v4zm0-5.333H6.334V4.167h1.333V5.5z","fill":"#348EF6"}})])
          )
        }
      }
    